import brand from '@helpers/brand';
import { tagLarge, tagSmall } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  &[data-size='large'] {
    ${tagLarge};
  }

  &[data-size='small'] {
    ${tagSmall};
  }

  &[data-variant='black'] {
    color: ${brand.black};
  }

  &[data-variant='green'] {
    color: ${brand.green};
  }

  &[data-variant='white'] {
    color: ${brand.white};
  }

  &[data-variant] {
    margin: 0;
  }
`;
const Date = styled.time ``;
const ArticleDateStyles = {
    Container,
    Date,
};
export default ArticleDateStyles;
